import React from 'react';

import { OrderDetailsOrder } from '@portal/components/orders/cancel/steps';
import { OrderSubtypeEnum, OrderTypeEnum } from '@portal/schema';

import { MovingReasons } from './moving';
import { OnboardingReasons } from './onboarding';

type ReasonsProps = {
  order: OrderDetailsOrder;
  orderType: OrderTypeEnum;
  orderSubtype: OrderSubtypeEnum;
};

export const Reasons = ({ order, orderType, orderSubtype }: ReasonsProps) => {
  if (orderSubtype === OrderSubtypeEnum.Onboarding) {
    return <OnboardingReasons order={order} />;
  } else if (orderType === OrderTypeEnum.Move) {
    return <MovingReasons order={order} />;
  }
  throw new Error('Cancellation page should only be loaded for an onboarding or move');
};
